(function() {

  function processShippingTimeMessaging() {
    // Eastern time "America/New_York"
    var nowEastern = moment();
    
    var nowEasternDay = nowEastern.day();
    var nowEasternHour = nowEastern.hour();

    // console.log(nowEasternDay, nowEasternHour);

    // If business day and before 5pm
    if((nowEasternDay > 0 && nowEasternDay < 6) && nowEasternHour < 17) {
      $('.with-stock .shipping-messaging-standard.--weekday').toggleClass('--hidden');
      $('.with-stock .shipping-messaging-quick').toggleClass('--hidden');
    }

    // If weekend
    if(nowEasternDay == 0 || nowEasternDay == 6) {
      $('.with-stock .shipping-messaging-standard.--weekday').toggleClass('--hidden');
      $('.with-stock .shipping-messaging-standard.--weekend').toggleClass('--hidden');
    }


  }
  
  
  $(document).ready(function() {
    $('.expansion-control-btn').on('click', function(e) {
      $(this).closest('.expanding-container-content')
        .toggleClass('--expanded');
  
      e.preventDefault();
    });

    processShippingTimeMessaging();
  
    
  });


})();